module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_consulenza-435b1b2fc08fea65013ef2499efc1c82.jpg";